import { useState, useEffect } from "react";
import { packageService } from "../services/packageService";

export function useDynamicPackages() {
  const [packages, setPackages] = useState(() => packageService.getCachedPackages());
  const [tiers, setTiers] = useState(() => packageService.getCachedTiers());

  useEffect(() => {
    // Initial fetch
    packageService.fetchPackages().then(res => {
      if (res?.packages) setPackages(res.packages);
      if (res?.tiers) setTiers(res.tiers);
    });

    const handleUpdate = (e) => {
      if (e.detail?.packages) {
        setPackages(e.detail.packages);
        setTiers(e.detail.tiers);
      } else {
        packageService.fetchPackages().then(res => {
          if (res?.packages) setPackages(res.packages);
          if (res?.tiers) setTiers(res.tiers);
        });
      }
    };

    window.addEventListener("packages-updated", handleUpdate);
    window.addEventListener("subscription-updated", handleUpdate);

    return () => {
      window.removeEventListener("packages-updated", handleUpdate);
      window.removeEventListener("subscription-updated", handleUpdate);
    };
  }, []);

  return { packages, tiers, refetch: () => packageService.fetchPackages() };
}
